import { OneInchNetwork, OneInchToken } from '@api';

import useTokenPriceInUSD from '@magic-swap/components/pages/MagicSwap/hooks/useTokenPriceInUSD';

export interface UseTokensPricesInUSDProps {
  network?: OneInchNetwork;
  fromToken?: OneInchToken;
  fromAmount: number;
  inverted: boolean;
  toToken?: OneInchToken;
  nativeToken?: OneInchToken;
}

const useTokensPricesInUSD = ({
  network,
  fromToken,
  fromAmount,
  inverted,
  toToken,
  nativeToken,
}: UseTokensPricesInUSDProps) => {
  const { tokenPriceInUSD: fromTokenPriceInUSD } = useTokenPriceInUSD({
    network,
    token: fromToken,
    fromAmount,
    inverted,
  });
  const { tokenPriceInUSD: toTokenPriceInUSD, isLoading: isLoadingToTokenPriceInUSD } =
    useTokenPriceInUSD({
      network,
      token: toToken,
      fromAmount,
      inverted,
    });
  const { tokenPriceInUSD: nativeTokenPriceInUSD } = useTokenPriceInUSD({
    network,
    token: nativeToken,
  });

  return {
    fromTokenPriceInUSD,
    toTokenPriceInUSD,
    isLoadingToTokenPriceInUSD,
    nativeTokenPriceInUSD,
  };
};

export default useTokensPricesInUSD;
